import type { MutableRefObject } from 'react';

import { apiFetchData } from 'apps/auth/helpers/api';

type ApiFetchFields = Parameters<typeof apiFetchData>[1];
type ControllerRef = Parameters<typeof apiFetchData>[2];

type PopupInstance = { close: () => void };
type PopupRef = MutableRefObject<PopupInstance | null> | { current?: PopupInstance | null } | null | undefined;

export interface ApiServiceProps<TFields = ApiFetchFields> {
    fields?: TFields;
    toggleSpinner: (show: boolean) => void;
    togglePopup: (show: boolean) => void;
}

export class ApiService {
    static fetch<TResponse = unknown, TFields = ApiFetchFields>(
        url: string,
        props: ApiServiceProps<TFields>,
        callback: (response: TResponse) => void,
        controllerRef?: ControllerRef,
        popupRef?: PopupRef,
    ): void {
        props.toggleSpinner(true);

        void apiFetchData<TResponse>(url, props.fields as ApiFetchFields, controllerRef)
            .then((json) => {
                callback(json);
            })
            .finally(() => {
                props.toggleSpinner(false);
                const popup = popupRef?.current;
                if (popup && typeof popup.close === 'function') {
                    popup.close();
                } else {
                    props.togglePopup(false);
                }
            });
    }

    static fetchWithoutSpinner<TResponse = unknown>(
        url: string,
        fields?: ApiFetchFields,
        callback?: (response: TResponse) => void,
        controllerRef?: ControllerRef,
    ): void {
        void apiFetchData<TResponse>(url, fields, controllerRef).then((json) => {
            if (callback) {
                callback(json);
            }
        });
    }
}
